import { type ProactiveAIBlock } from '../ai-spelling-grammar/states';

export interface AISGBetterTrafficProjectionsPluginState {
	proactiveAIBlocks?: ProactiveAIBlock[];
	splitParagraphIntoSentences: boolean;
	totalRequests: number;
	partLengths: number[];
	durationBetweenRequests: number[];
	partsPerRequests: number[];
	lastRequestTime: number;
}

export enum ACTIONS {
	UPDATE_PLUGIN_STATE,
}

export type AISGBetterTrafficProjectionsAction = {
	type: ACTIONS.UPDATE_PLUGIN_STATE;
	data: {
		proactiveAIBlocks?: ProactiveAIBlock[];
	};
};
